import type { Api, ApiConfig } from './apiFactory';
import apiFactory from './apiFactory';

const apis: Record<string, Api> = {};
let gridPlannerConfig: ApiConfig;

export default {
  initialize(config: ApiConfig) {
    gridPlannerConfig = {
      ...config,
      timeout: 5000
    };
  },

  setBasePath(hostUrl: string[]) {
    hostUrl.forEach(url => {
      apis[url] = apiFactory(gridPlannerConfig, 'Bearer');
      apis[url].setBasePath(url);
    });
  },

  async getTenantsMapping(
    controller?: AbortController
  ): Promise<TenantIdentityProviderMapping> {
    const tenantIdentityMapping = await Promise.allSettled(
      Object.values(apis).flatMap(api =>
        this.getEnvTenantsMapping(api, controller)
      )
    );

    return takeCompleted(tenantIdentityMapping);
  },

  getEnvTenantsMapping(api: Api, controller?: AbortController) {
    return api.get<TenantIdentityProviderMapping>(
      `/tenants`,
      undefined,
      controller ? { signal: controller.signal } : undefined
    );
  }
};

export type TenantIdentityProviderMapping = {
  tenantId: string;
  organizationName: string;
  tenantName: string;
  identityProvider: string;
}[];

function takeCompleted(
  tenantIdentityMapping: PromiseSettledResult<TenantIdentityProviderMapping>[]
): TenantIdentityProviderMapping | PromiseLike<TenantIdentityProviderMapping> {
  return tenantIdentityMapping
    .filter(result => result.status === 'fulfilled')
    .map(
      result =>
        (result as PromiseFulfilledResult<TenantIdentityProviderMapping>).value
    )
    .flat();
}
